import React, { useState, useEffect } from 'react';
import { getSettings, updateSettings } from '../../services/settingsService';
import { FiEdit2, FiCheck, FiX } from 'react-icons/fi';
import './Settings.css';

const Settings = () => {
  const [settings, setSettings] = useState(null);
  const [editableSettings, setEditableSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  
  useEffect(() => {
    console.log("API Key:", process.env.REACT_APP_GOOGLE_MAPS_API_KEY);

    fetchSettings();
  }, []);
  
  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await getSettings();
      setSettings(data);
      setEditableSettings(JSON.parse(JSON.stringify(data))); // Copia profunda
      setError(null);
    } catch (err) {
      setError('Error al cargar las configuraciones');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleSave = async () => {
    try {
      setLoading(true);
      await updateSettings(editableSettings);
      setSettings(editableSettings);
      setSuccess(true);
      setIsEditing(false);
      
      // Ocultar mensaje de éxito después de 3 segundos
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (err) {
      setError('Error al guardar la configuración');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  
  const handleCancel = () => {
    // Restaurar valores originales
    setEditableSettings(JSON.parse(JSON.stringify(settings)));
    setIsEditing(false);
  };
  
  const handleEdit = () => {
    setIsEditing(true);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableSettings(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  return (
    <div className="settings-container">
      <h1 className="page-title">Configuración</h1>
      
      {loading && !settings ? (
        <div className="loading-state">
          <p>Cargando configuración...</p>
        </div>
      ) : error ? (
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchSettings}>Reintentar</button>
        </div>
      ) : (
        <>
          {success && (
            <div className="success-message">
              Configuración guardada correctamente
            </div>
          )}
          
          <div className="settings-card">
            <div className="settings-section">
              <div className="settings-header">
                <h2>Datos del negocio</h2>
                {!isEditing ? (
                  <button className="edit-button" onClick={handleEdit}>
                    <FiEdit2 /> Editar
                  </button>
                ) : (
                  <div className="edit-actions">
                    <button className="cancel-button" onClick={handleCancel}>
                      <FiX /> Cancelar
                    </button>
                    <button className="save-button" onClick={handleSave}>
                      <FiCheck /> Guardar
                    </button>
                  </div>
                )}
              </div>
              
              <div className="settings-form">
                <div className="form-group">
                  <label>Nombre y apellido</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="businessName"
                      value={editableSettings.businessName || ''}
                      onChange={handleInputChange}
                      className="settings-input"
                    />
                  ) : (
                    <div className="settings-value">{settings.businessName}</div>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Teléfono del negocio</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="businessPhone"
                      value={editableSettings.businessPhone || ''}
                      onChange={handleInputChange}
                      className="settings-input"
                    />
                  ) : (
                    <div className="settings-value">{settings.businessPhone}</div>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Dirección del negocio</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="businessAddress"
                      value={editableSettings.businessAddress || ''}
                      onChange={handleInputChange}
                      className="settings-input"
                    />
                  ) : (
                    <div className="settings-value">{settings.businessAddress}</div>
                  )}
                </div>
                
                {!isEditing && settings.businessAddress && (
  <div className="map-container">
    <div className="map-placeholder">
      <iframe
        title="Ubicación del negocio"
        width="100%"
        height="200"
        frameBorder="0"
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}&q=${encodeURIComponent(settings.businessAddress)}`}
        allowFullScreen
      ></iframe>
    </div>
    <div className="map-caption">Ubicación del negocio</div>
  </div>
)}
                
                <div className="form-group">
                  <label>Datos adicionales</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="businessHours"
                      value={editableSettings.businessHours || ''}
                      onChange={handleInputChange}
                      className="settings-input"
                    />
                  ) : (
                    <div className="settings-value">{settings.businessHours}</div>
                  )}
                </div>
                
                <div className="form-group">
                  <label>Mensaje genérico</label>
                  {isEditing ? (
                    <textarea
                      name="welcomeMessage"
                      value={editableSettings.welcomeMessage || ''}
                      onChange={handleInputChange}
                      rows={8}
                      className="settings-textarea"
                    />
                  ) : (
                    <div className="settings-value welcome-message">
                      {settings.welcomeMessage}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Settings;